const dummyPackages = [
  {
    id: 'basic',
    name: 'Basic Digital Package',
    price: '0',
    note: '+ £12 Companies House Fee',
    badge: 'Most Popular',
    active: true,
    features: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
    bestFor: 'Sole traders and startups testing ideas',
  },
  {
    id: 'standard',
    name: 'Standard Package',
    price: '9.99',
    note: '+ £12 Companies House Fee',
    active: true,
    features: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
    ],
    bestFor: 'Businesses needing physical documents and address',
  },
  {
    id: 'premium',
    name: 'Premium Package',
    price: '29.99',
    note: '+ £12 Companies House Fee',
    badge: 'Best Value',
    active: true,
    features: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
    ],
    bestFor: 'Growing businesses needing full support',
  },
  {
    id: 'all_inclusive',
    name: 'All-Inclusive Package',
    price: '99.99',
    note: '+ £12 Companies House Fee',
    active: true,
    features: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
      '32',
      '33',
      '34',
      '35',
    ],
    bestFor: 'Businesses wanting complete setup and first-year support',
  },
];

const dummyFeatures = [
  {
    id: '1',
    name: 'Instant company formation (usually within 3-6 hours)',
    active: true,
    category: 'Formation',
  },
  {
    id: '2',
    name: 'Digital certificate of incorporation',
    active: true,
    category: 'Formation',
  },
  {
    id: '3',
    name: 'Digital memorandum & articles of association',
    active: true,
    category: 'Formation',
  },
  {
    id: '4',
    name: 'Free company name check',
    active: true,
    category: 'Formation',
  },
  {
    id: '5',
    name: 'Digital company register',
    active: true,
    category: 'Compliance',
  },
  {
    id: '6',
    name: 'HMRC tax registration (CT41G & UTR)',
    active: true,
    category: 'Tax',
  },
  {
    id: '7',
    name: 'VAT registration assistance',
    active: true,
    category: 'Tax',
  },
  {
    id: '8',
    name: 'Basic compliance alerts',
    active: true,
    category: 'Compliance',
  },
  { id: '9', name: 'Email support', active: true, category: 'Support' },
  {
    id: '10',
    name: 'Printed certificate of incorporation',
    active: true,
    category: 'Formation',
  },
  {
    id: '11',
    name: 'Printed memorandum & articles',
    active: true,
    category: 'Formation',
  },
  {
    id: '12',
    name: 'Registered office address (London or nationwide) for 12 months',
    active: true,
    category: 'Address',
  },
  {
    id: '13',
    name: 'Mail forwarding service (20 items)',
    active: true,
    category: 'Address',
  },
  {
    id: '14',
    name: 'Director service address',
    active: true,
    category: 'Address',
  },
  {
    id: '15',
    name: 'Access to business banking offers',
    active: true,
    category: 'Banking',
  },
  {
    id: '16',
    name: 'Priority customer support',
    active: true,
    category: 'Support',
  },
  {
    id: '17',
    name: 'Free accounting software trial',
    active: true,
    category: 'Software',
  },
  {
    id: '18',
    name: 'Business trading address',
    active: true,
    category: 'Address',
  },
  {
    id: '19',
    name: 'Unlimited mail forwarding',
    active: true,
    category: 'Address',
  },
  {
    id: '20',
    name: '.co.uk domain name (1 year)',
    active: true,
    category: 'Digital',
  },
  {
    id: '21',
    name: 'Professional email address',
    active: true,
    category: 'Digital',
  },
  {
    id: '22',
    name: 'Company secretarial service',
    active: true,
    category: 'Compliance',
  },
  {
    id: '23',
    name: 'VAT registration included',
    active: true,
    category: 'Tax',
  },
  {
    id: '24',
    name: 'Payroll registration assistance',
    active: true,
    category: 'Tax',
  },
  {
    id: '25',
    name: 'Dedicated account manager',
    active: true,
    category: 'Support',
  },
  {
    id: '26',
    name: 'Legal document templates',
    active: true,
    category: 'Legal',
  },
  {
    id: '27',
    name: '12 months accounting support (bookkeeping)',
    active: true,
    category: 'Accounting',
  },
  {
    id: '28',
    name: 'Annual Confirmation Statement filing',
    active: true,
    category: 'Compliance',
  },
  {
    id: '29',
    name: 'Corporate banking introduction',
    active: true,
    category: 'Banking',
  },
  {
    id: '30',
    name: 'Business insurance consultation',
    active: true,
    category: 'Insurance',
  },
  {
    id: '31',
    name: 'Tax planning consultation',
    active: true,
    category: 'Tax',
  },
  {
    id: '32',
    name: 'Website hosting (1 year)',
    active: true,
    category: 'Digital',
  },
  { id: '33', name: 'SSL certificate', active: true, category: 'Digital' },
  { id: '34', name: 'Logo design service', active: true, category: 'Design' },
  {
    id: '35',
    name: 'Priority same-day formation',
    active: true,
    category: 'Formation',
  },
];

export { dummyPackages, dummyFeatures };
